import React from 'react';

import classes from './CurriculumAssignmentContent.module.css';

import AddIcon from '../../../assets/icons/icon-plus-blue.svg';
import EditIcon from '../../../assets/icons/icon-edit-blue.svg';
import { IsListEmpty, IsObjectEmpty } from '../../../utilities/CommonMethods';
import AssignmentQuizDetailsSection from '../AssignmentQuizDetailsSection/AssignmentQuizDetailsSection';
import AssignmentProblemCard from '../../Cards/AssignmentProblemCard/AssignmentProblemCard';
import AssignmentProblemForm from '../../Forms/AssignmentProblemForm/AssignmentProblemForm';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import AssignmentViewCard from '../../Cards/AssignmentViewCard/AssignmentViewCard';

class CurriculumAssignmentContent extends React.Component {

    state = {
        assignmentProblems: [],
        showQuizLoader: true,
        showAddNewProblemForm: false,
        viewAssignment: false,
        openStatusList: [],
    }

    collapseAllProblemsClick = () => {
        const updatedState = this.state.collapseAll;
        this.setState({ collapseAll: !updatedState });
    }

    onEditProblemIconClick = (problemId, pos) => {
        // alert('Edit Problem => ' + problemId + ' ' + pos);
        let updatedProblemsList = [...this.state.assignmentProblems];
        updatedProblemsList[pos].showEditForm = true;

        this.setState({ assignmentProblems: updatedProblemsList });
    }

    // onDeleteProblemClick = (problemId, pos) => {
    //     alert('Delete Problem => ' + problemId + ' ' + pos)
    // }

    onAddNewProblemClick = () => {
        this.setState({ showAddNewProblemForm: true });
    }

    hideAddNewProblemForm = () => {
        this.setState({ showAddNewProblemForm: false });
    }

    hideEditForm = (pos) => {
        // alert('Clicked hide edit form ' + pos);
        let updatedProblemsList = [...this.state.assignmentProblems];
        updatedProblemsList[pos].showEditForm = false;

        this.setState({ assignmentProblems: updatedProblemsList });
    }

    onProblemClick = (problemId, index) => {
        // alert("Problem Clicked => " + problemId + " " + index);
        let updatedProblemsList = [...this.state.assignmentProblems];
        updatedProblemsList[index].viewProblem = true;

        this.setState({ assignmentProblems: updatedProblemsList });
    }


    addNewAssignmentProblemClicked = (problemData, pos) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.addNewAssignmentProblem(this.props.data.assignmentDetails.topicId, problemData)
            .then(response => {
                responseObj = response.result;
                // console.log('Add New Assignment Problem Data => ', responseObj)

                let updatedProblemsList = [...this.state.assignmentProblems];
                updatedProblemsList.push(responseObj);

                this.props.updateAssignmentDetails(this.props.data.assignmentDetails.topicId);

                this.props.onSuccessDialogShow('Problem added successfully.', 'OKAY');


                this.setState({ showContentLoader: false, showAddNewProblemForm: false, assignmentProblems: updatedProblemsList });


            })
            .catch(err => {
                console.log('Add New Quiz Question error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    editAssignmentProblemClicked = (problemId, problemData, pos) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.updateAssignmentProblem(problemId, problemData)
            .then(response => {
                responseObj = response.result;
                // console.log('Edit Assignment Question Data => ', responseObj)
                // let updatedProblemsList = [...this.state.assignmentProblems];
                // updatedProblemsList.push(responseObj);

                let updatedProblemsList = [...this.state.assignmentProblems];
                updatedProblemsList[pos] = responseObj;

                this.setState({ showContentLoader: false, assignmentProblems: updatedProblemsList });
                this.props.onSuccessDialogShow('Problem updated successfully.', 'OKAY');
                this.props.updateAssignmentDetails(this.props.data.assignmentDetails.topicId);
            })
            .catch(err => {
                console.log('Edit Assignment Problem error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    onCloseProblem = (index) => {
        let updatedProblemsList = [...this.state.assignmentProblems];
        updatedProblemsList[index].viewProblem = false;

        this.setState({ assignmentProblems: updatedProblemsList });

    }

    componentDidMount() {
        if (!IsObjectEmpty(this.props.data) && !IsListEmpty(this.props.data.assignmentProblems)) {
            this.setState({ assignmentProblems: this.props.data.assignmentProblems });
        }
    }

    componentDidUpdate(prevProps) {
        if (IsObjectEmpty(prevProps.data) && !IsObjectEmpty(this.props.data) && (prevProps.data.assignmentProblems !== this.props.data.assignmentProblems)) {
            this.setState({ assignmentProblems: this.props.data.assignmentProblems });
        }
    }

    render() {
        const problemsList = !IsListEmpty(this.state.assignmentProblems)
            ? this.state.assignmentProblems.map((problem, index) => {
                return <li key={index} >
                    {
                        problem.viewProblem ?
                            <AssignmentViewCard pos={index} assignment={problem}
                                onCloseProblem={this.onCloseProblem}
                            />
                            : problem.showEditForm
                                ? <AssignmentProblemForm
                                    pos={index}
                                    forEdit={true}
                                    data={problem}
                                    hideEditForm={this.hideEditForm}
                                    editAssignmentProblemClicked={this.editAssignmentProblemClicked}

                                    onSuccessDialogShow={this.onSuccessDialogShow}
                                    onFailureDialogShow={this.props.onFailureDialogShow}
                                    showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                                    redirectToUnauthorized={this.props.redirectToUnauthorized}
                                    redirectToNotFound={this.props.redirectToNotFound}
                                    redirectToServerError={this.props.redirectToServerError}
                                />
                                : <div className={classes.AssignmentCardDiv}>
                                    <div onClick={() => [this.onProblemClick(problem.id, index), this.setState({ viewAssignment: true, problemClicked: index })]}>
                                        <AssignmentProblemCard data={problem} pos={index} forInstructor={true} />
                                    </div>
                                    <img src={EditIcon} alt="Problem Edit Icon" className={classes.EditIcon} onClick={() => this.onEditProblemIconClick(problem.id, index)} />
                                </div>
                    }
                </li>
            }) : null;

        return (
            <div className={classes.CurriculumAssignmentContent}>

                <AssignmentQuizDetailsSection
                    forPMPage={this.props.forPMPage}
                    batchCode={this.props.batchCode}
                    moduleName={this.props.moduleName}
                    data={this.props.data}
                    result={this.props.data.assignmentDetails}
                    type="Assignment"
                    showEditAssignmentPopup={this.props.showEditAssignmentPopup}
                />

                <div className={classes.ProblemsSection}>
                    <p className={classes.CardHeading}>Assignment Problems</p>

                    <div className={classes.ProblemsContainer}>
                        <ul className={classes.ProblemsList}>
                            {problemsList}
                        </ul>
                    </div>
                </div>

                {
                    this.state.showAddNewProblemForm
                        ? <div className={classes.AddNewQuestionFormContainer} >
                            <AssignmentProblemForm
                                hideForm={this.hideAddNewProblemForm}
                                addNewAssignmentProblemClicked={this.addNewAssignmentProblemClicked} />
                        </div>
                        : <div className={classes.AddNewProblemDiv} onClick={this.onAddNewProblemClick}>
                            <img src={AddIcon} alt="Add New Assignment Problem Icon" className={classes.AddIcon} />
                            Add New Problem
                        </div>
                }

            </div>
        );
    }
}

export default CurriculumAssignmentContent;